module.exports = __webpack_public_path__ + "static/screen-web-schedule-2d31772f6ab112daacc78e50e85fe0bc.png";